import API_DOMAIN, { CMS_DOMAIN } from './apiDomain'
import ApiClient from './client'

export const api = new ApiClient(API_DOMAIN || '', CMS_DOMAIN)
// export default api;
